export default "__VITE_ASSET__BiRPlY_E__"